import {
  Block,
  HeadingXXLarge,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import homepageMainSectionImage from "#/assets/home-hero-section.svg"
import CurrencySymbol from "#/shared/components/CurrencySymbol"
import { useMobileScreen } from "#/shared/hooks"

import HomepageMainSectionBorrowButton from "./HomepageMainSectionBorrowButton"

export default function HomepageMainSectionGuest() {
  const isMobileScreen = useMobileScreen()
  const [css, theme] = useStyletron()

  return (
    <Block className={css({ position: "relative" })}>
      <Block
        paddingBottom={isMobileScreen ? theme.sizing.scale1000 : "80px"}
        className={css({ position: "relative", zIndex: 2 })}
      >
        <HeadingXXLarge marginBottom={theme.sizing.scale600}>
          Borrow on your bitcoin, <br />
          collect cool stuff.
        </HeadingXXLarge>
        <ParagraphLarge
          color={theme.colors.contentTertiary}
          marginBottom={theme.sizing.scale900}
        >
          Use <CurrencySymbol token="mBTC" /> as collateral to borrow{" "}
          <CurrencySymbol token="MUSD" /> and <br />
          claim your test swag.
        </ParagraphLarge>
        {!isMobileScreen && <HomepageMainSectionBorrowButton />}
      </Block>
      <Block
        as="img"
        display={["none", "none", "none", "block"]}
        src={homepageMainSectionImage}
        alt="Homepage Hero"
        className={css({
          position: "absolute",
          top: "-148px",
          right: "5%",
        })}
      />
    </Block>
  )
}
